import { isBefore } from 'date-fns/isBefore';
import { subHours } from 'date-fns/subHours';

import { FlattenedOrderStatuses } from '@sg/graphql-schema';

import { ignoreTimezone } from '@order/utils';

import { getOrderTime } from './getOrderTime';

/**
 * Orders are considered past if their completed time is 1hrs in the past.
 */
export const checkIfPastOrder = ({
  order,
  flattenedOrderStatus = FlattenedOrderStatuses.Failed,
}: IsOrderPastProps) => {
  const canBePast = flattenedOrderStatus === 'completed';

  const orderTime = order ? (getOrderTime(order) ?? '') : '';
  const orderTimeDate = orderTime ? ignoreTimezone(orderTime) : undefined;

  const oneHourAgo = subHours(new Date(), 1);
  const isPast = orderTimeDate ? isBefore(orderTimeDate, oneHourAgo) : false;

  return canBePast && isPast;
};

type IsOrderPastProps = Readonly<{
  order?: {
    wantedTime?: string | null;
    deliveryOrderDetail?: {
      estimatedDeliveryTime?: string | null;
    } | null;
  };
  flattenedOrderStatus?: FlattenedOrderStatuses;
}>;
